import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ArrowLeft, ShieldCheck } from "lucide-react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import api from "../lib/api";
import { toast } from "sonner";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/admin/login", { email, password });
      localStorage.setItem("cct_admin_token", data.token);
      localStorage.setItem("cct_admin", JSON.stringify(data.admin));
      toast.success(`Welcome, ${data.admin.name}`);
      navigate("/admin/dashboard");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-cct-ambient">
      <Header />
      <main className="max-w-md mx-auto px-4 pb-20">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-sm text-slate-600 hover:text-cct-blue mb-6"
        >
          <ArrowLeft className="w-4 h-4" /> Back to portal
        </Link>
        <div className="fade-up bg-white border border-slate-200 rounded-2xl shadow-sm p-8">
          <div className="w-12 h-12 rounded-xl bg-cct-blue/10 flex items-center justify-center mb-4">
            <ShieldCheck className="w-6 h-6 text-cct-blue" />
          </div>
          <h1 className="font-display text-3xl font-semibold text-cct-blue">
            Admin Login
          </h1>
          <p className="mt-1 text-sm text-slate-600">
            CCT Admissions · Staff access only
          </p>

          <form onSubmit={onSubmit} className="mt-6 space-y-4">
            <label className="block">
              <span className="text-sm font-medium text-slate-700">Email</span>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="mt-1.5 w-full rounded-md border border-slate-300 bg-white px-3.5 py-2.5 text-sm input-focus"
              />
            </label>
            <label className="block">
              <span className="text-sm font-medium text-slate-700">Password</span>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="mt-1.5 w-full rounded-md border border-slate-300 bg-white px-3.5 py-2.5 text-sm input-focus"
              />
            </label>
            <button
              disabled={loading}
              className="w-full bg-cct-blue text-white font-semibold py-2.5 rounded-md hover:bg-[#1a3380] disabled:opacity-60"
            >
              {loading ? "Signing in..." : "Sign In"}
            </button>
          </form>

          <div className="mt-6 pt-6 border-t border-slate-200 text-xs text-slate-500 bg-slate-50 -mx-8 -mb-8 px-8 pb-6 rounded-b-2xl">
            <div className="font-semibold uppercase tracking-wider mb-1">
              Demo access
            </div>
            admin@cambridgecollegebc.com / Admin@123
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
